import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { initAuth } from '../redux/user.redux';
import { initChat, connectChatSocket, closeChatSocket } from '../redux/chat.redux';
import IconRail from '../components/icon-rail';
import ChatList from '../components/chat-list';
import DetailArea from '../components/detail-area';
import MobileLayout from '../components/mobile-layout';
import Watermark from '../components/Watermark';
import { useIsMobile } from '../hooks/use-is-mobile';
import { anonIdOf } from '../lib/anon';
import { userBackground } from '../lib/background';

function Chat() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userState = useAppSelector((s) => s.user);
  const isMobile = useIsMobile();

  useEffect(() => {
    dispatch(initAuth())
      .unwrap()
      .catch(() => {});
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (userState.loading) return;
    if (!userState.isLogin) {
      navigate('/login', { replace: true });
      return;
    }
    dispatch(initChat()).then(() => {
      dispatch(connectChatSocket());
    });
    // eslint-disable-next-line
  }, [userState.loading, userState.isLogin]);

  // 组件卸载(登出/跳转登录页)时关闭连接,停止自动重连
  useEffect(() => {
    return () => {
      dispatch(closeChatSocket());
    };
    // eslint-disable-next-line
  }, []);

  if (userState.loading) {
    return (
      <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!userState.isLogin) return null;

  const me = userState.user;
  const dateStr = new Date().toLocaleDateString('zh-CN');
  const watermarkText = me ? `${me.nickname || me.username} · 匿名${anonIdOf(me.id)} · ${dateStr}` : '';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        background: me ? userBackground(me.id) : undefined,
      }}
    >
      {isMobile ? (
        <MobileLayout />
      ) : (
        <>
          <IconRail />
          <ChatList />
          <DetailArea />
        </>
      )}
      {watermarkText && <Watermark text={watermarkText} />}
    </Box>
  );
}

export default Chat;

